<template>
  <div v-if="
    (measureFields && measureFields.length) ||
    (dimensionFields && dimensionFields.length)
  " class="p-3">
    <b-table :id="tableId" class="table-reporting" :class="[{ hideGroups: hideGroups }, customTableClass]" responsive
      sticky-header no-border-collapse striped head-variant="dark" show-empty label-sort-asc="" label-sort-desc="" label-sort-clear=""
      :sort-by.sync="sortedColumn" :sort-desc.sync="isSortedDescending" :sort-compare="sortCompareTableFields"
      :fields="columnTable" :items="dataTable" :busy="loading" :empty-text="$t('global.noResult')" v-bind="$attrs"
      :bordered="true" :tbody-tr-class="rowClass" @sort-changed="sortChanged">
      <!-- Affichage du header en html / remplacement des sauts de ligne -->
      <template #head()="data">
        <!-- eslint-disable-next-line vue/no-v-html -->
         <!-- Affichage possbile d'un tooltip d'aide sur le header -->
        <div
          v-b-tooltip.hover="{
            title: getTooltipHeader(data),
            customClass: 'tooltip-w-2x'
          }"
          v-html="data.label && data.label.replace(/\n/g, '<br/>')"
        />
      </template>

      <template v-if="groupHeaders.length || tableHeader || topGroupHeaders.length" slot="thead-top" slot-scope="{}">
        <tr v-if="tableHeader">
          <th class="col-align-left" :colspan="dimensionFields.length + measureFields.length"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]">
            {{ tableHeader }}
          </th>
        </tr>
        <tr v-if="topGroupHeaders.length">
          <th v-if="dimensionFields.length" :colspan="dimensionFields.length"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
          <th v-for="(group, index) in topGroupHeaders" :key="group.label || index" :colspan="group.nbOfMeasures"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]">
            {{ group.label }}
          </th>
        </tr>
        <tr v-if="groupHeaders.length">
          <th v-if="dimensionFields.length" :colspan="dimensionFields.length"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
          <th v-for="(group, index) in groupHeaders" :key="group.label || index" :colspan="group.nbOfMeasures"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]">
            {{ group.label }}
          </th>
        </tr>
      </template>
      <template #cell()="data">
        <span
          :class="computedTdClass(data)"
          v-b-tooltip.hover="shouldHaveTooltip(data)"
        >
          {{ data.value }}
        </span>
      </template>

      <!-- eslint-disable -->
      <template v-if="
        !loading &&
        dataTable &&
        dataTable.length &&
        (displayTotal || displayAverage)
      " slot="custom-foot" slot-scope="{}">
        <tr v-if="displayTotal">
          <th v-if="!dimensionFieldsTotal" :colspan="dimensionFields.length"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]">
            {{ $t("Display.total") }}
          </th>

          <th v-for="(total, index) of dimensionFieldsTotal" v-else :key="index" :class="{
            'col-align-right':
              dimensionFields[index] && cellStyleFormatter(totalsData[dimensionFields[index].key], dimensionFields[index].key, true).includes('col-align-right')
          }" v-html="total" :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
          <th v-for="col of measureFields" :key="col.key" :class="{
            danger:
              totalsData['_cellVariants'] &&
              totalsData['_cellVariants'][col.key] === 'danger',
            success:
              totalsData['_cellVariants'] &&
              totalsData['_cellVariants'][col.key] === 'success',
            'col-align-left':
              totalsData['column-class'] &&
              totalsData['column-class'][col.key] === 'col-align-left',
            'col-align-right':
              cellStyleFormatter(totalsData[col.key], col.key, true).includes('col-align-right')
          }" v-html="exportMode
            ? totalsData[col.key]
            : valueFormatter(totalsData[col.key], col.key, true)
            " :data-num-fmt="getExportFormat(totalsData[col.key], col.key, true, dataTable[0]['Site.currency'])"
            :data-a-h="cellStyleFormatter(totalsData[col.key], col.key, true).includes('col-align-right') ? 'right' : 'center'"
            :data-t="isNaN(totalsData[col.key]) ? 's' : 'n'"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
        </tr>
        <tr v-if="displayAverage">
          <th :colspan="dimensionFields.length" v-html="$t('Display.average')"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
          <th v-for="col of measureFields" :key="col.key" v-html="exportMode
            ? averagesData[col.key]
            : valueFormatter(totalsData[col.key], col.key, true)
            " :data-num-fmt="getExportFormat(totalsData[col.key], col.key, true, dataTable[0]['Site.currency'])"
            :data-a-h="cellStyleFormatter(totalsData[col.key], col.key, true).includes('col-align-right') ? 'right' : 'center'"
            :data-t="isNan(averagesData[col.key]) ? 's' : 'n'"
            :[excelAttrThFullKeys[0]]="excelAttrThFull[excelAttrThFullKeys[0]]"
            :[excelAttrThFullKeys[1]]="excelAttrThFull[excelAttrThFullKeys[1]]"
            :[excelAttrThFullKeys[2]]="excelAttrThFull[excelAttrThFullKeys[2]]"
            :[excelAttrThFullKeys[3]]="excelAttrThFull[excelAttrThFullKeys[3]]"
            :[excelAttrThFullKeys[4]]="excelAttrThFull[excelAttrThFullKeys[4]]"
            :[excelAttrThFullKeys[5]]="excelAttrThFull[excelAttrThFullKeys[5]]"
            :[excelAttrThFullKeys[6]]="excelAttrThFull[excelAttrThFullKeys[6]]"
            :[excelAttrThFullKeys[7]]="excelAttrThFull[excelAttrThFullKeys[7]]" />
        </tr>
      </template>
      <!-- eslint-enable -->
      <b-spinner slot="table-busy" variant="primary" />
    </b-table>
  </div>
</template>

<script>
import TableTools from "@/utils/tableTools";
import { getExportNumFormat } from "@/filter/exportFormat";

export default {
  name: "TableRenderer",
  props: {
    /** Préfixe de l'identifiant de la table pour les exports ayant plusieurs groupes de tableaux */
    tableIdPrefix: {
      type: String,
      default() {
        return "";
      },
    },
    /** Identifiant de la table pour les exports ayant plusieurs tableaux */
    tableNumber: {
      type: String,
      default() {
        return "0";
      },
    },
    dataTable: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Colonnes à afficher en premier, non inclus dans un groupe, ne pouvant pas avoir de Total/Moyenne (espace utilisé pour le libellé "Total" etc) */
    dimensionFields: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Autres colonnes, dans l'ordre */
    measureFields: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Facultatif : header pour toute la table */
    tableHeader: {
      type: String,
      default() {
        return "";
      },
    },
    /** Facultatif : ligne supplémentaire de header
     * type: {
     *    label: <libellé du groupe>
     *    nbOfMeasures: <nombre de colonnes de measureFields à inclure dans ce groupe>
     * }
     */
    groupHeaders: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Facultatif : ligne supplémentaire de header au dessus du groupHeader
     * type: {
     *    label: <libellé du groupe>
     *    nbOfMeasures: <nombre de colonnes de measureFields à inclure dans ce groupe>
     * }
     */
    topGroupHeaders: {
      type: Array,
      default() {
        return [];
      },
    },
    /** Facultatif : ligne de données à afficher en footer avec un libellé "Moyenne" */
    averagesData: {
      type: Object,
      default() {
        return null;
      },
    },
    /** Facultatif : ligne de données à afficher en footer avec un libellé "Total" */
    totalsData: {
      type: Object,
      default() {
        return null;
      },
    },
    dataReady: {
      type: Boolean,
      default() {
        return false;
      },
    },
    /** Facultatif : Nom de la colonne par laquelle le tableau doit être ordonné par défaut (à charque rechargement de la table, ASC) */
    defaultSortedColumn: {
      type: String,
      default() {
        return "";
      },
    },
    /** Facultatif : sens du tri par défaut (false = asc, true = desc) */
    defaultSortedDesc: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideGroups: {
      type: Boolean,
      default() {
        return false;
      },
    },
    /** Classe à appliquer sur l'ensemble des tables, pour indiquer leur largeur par exemple  */
    customTableClass: {
      type: String,
      default() {
        return "";
      },
    },
    /** Attributs à appliquer aux th pour l'export excel : 8 maximum utilisables actuellement. */
    excelAttrTh: {
      type: Object,
      default() {
        return null;
      },
    },
    exportMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data: function () {
    return {
      /** Nom de la colonne par laquelle le tableau est ordonné (ASC) :
       * peut être initialisé avec une valeur par défaut par exemple, reste synchro avec les choix utilisateurs ensuite*/
      sortedColumn: "",
      isSortedDescending: false,
      dimensionFieldsTotal: null,
      loading: true,
    };
  },
  computed: {
    /** Identifiant HTML de la table pour l'export */
    tableId: function () {
      return `table-reporting-id-${this.tableIdPrefix}${this.tableNumber}`;
    },
    displayTotal: function () {
      if (!this.totalsData) return false;
      var keys = Object.keys(this.totalsData);
      if (keys === undefined) return false;
      return keys.length > 0;
    },
    displayAverage: function () {
      if (!this.averagesData) return false;
      var keys = Object.keys(this.averagesData);
      if (keys === undefined) return false;
      return keys.length > 0;
    },
    columnTable: function () {
      if (!this.dimensionFields || !this.measureFields) return [];
      return this.dimensionFields.concat(this.measureFields);
    },
    /** Attributs à appliquer aux th pour l'export excel, complétés par des propriétés bidons pour en avoir toujours 8.
     * Permet un peu de souplesse pour ajouter facilement jusqu'à 8 attributs, car pas possible d'utiliser directement une liste.
     */
    excelAttrThFull: function () {
      const nbKeys = this.excelAttrTh
        ? Object.keys(this.excelAttrTh).length
        : 0;
      let filler = {};
      for (let i = nbKeys; i < 8; i++) {
        filler[i] = null;
      }
      return this.excelAttrTh ? { ...this.excelAttrTh, ...filler } : filler;
    },
    excelAttrThFullKeys: function () {
      return Object.keys(this.excelAttrThFull);
    },
  },
  watch: {
    dataReady(newValue, oldValue) {
      this.initTable(newValue, oldValue);
    },
  },
  created() {
    // Si les données étaient déjà prêtes, on initialise la table, sinon le watcher s'en occupe
    this.initTable(this.dataReady, false);
  },
  methods: {
    initTable: function (dataReady, dataReadyOldValue) {
      var self = this;
      if (dataReady && !dataReadyOldValue) {
        // Réinitialisation de la colonne de tri par défaut quand le chargement est terminé
        self.sortedColumn = self.defaultSortedColumn;
        self.isSortedDescending = self.defaultSortedDesc;
      }
      //cas des totaux sur les colonnes dimension
      if (
        self.totalsData &&
        self.dimensionFields.find(
          (col) => self.totalsData[col.key] !== undefined
        )
      ) {
        self.dimensionFieldsTotal = self.dimensionFields.map((col, index) => {
          let total = self.totalsData[col.key];
          if (index === 0 && !total) {
            return self.$t("Display.total");
          } else {
            return total;
          }
        });
      }

      self.loading = !dataReady;
    },
    sortCompareTableFields: function (a, b, key) {
      return TableTools.Helper.sortCompareTableFields(a, b, key);
    },
    valueFormatter: function (value, key, displayZero) {
      return TableTools.Helper.valueFormatter(value, key, displayZero, this.dataTable[0]?.["Site.currency"]);
    },
    cellStyleFormatter: function (value, key, displayZero) {
      return TableTools.Helper.cellStyleFormatter(value, key, displayZero);
    },
    rowClass: function (item, type) {
      if (!item || type !== "row") return;
      if (item.groupLevel !== undefined)
        return "table-row-group-level-" + item.groupLevel.toString();
    },
    sortChanged(e) {
      this.$emit("sort-changed", {
        tableNumber: this.tableNumber,
        event: e,
      });
    },

    getExportFormat(value, key, displayZero, siteCurrency) {
      return getExportNumFormat(value, key, displayZero, siteCurrency);
    },

    computedTdClass(data) {
      const tdClass = data.field.tdClass

      if (typeof tdClass === 'function') {
        return tdClass(data.value, data.field.key, data.item)
      }

      return tdClass || ''
    },

    computedThAttr(data){
      const thAttr = data.field.thAttr;

      if(typeof thAttr === 'function') {
        return thAttr(data.value, data.field.key, data.item);
      }

      return thAttr || '';
    },

    shouldHaveTooltip(data) {
      const classes = this.computedTdClass(data)

      return classes && classes.includes('col-ellipsis')
        ? data.value
        : null
    },

    getTooltipHeader(data) {
      // here we retrieving data attributes of <th>
      const attrs = this.computedThAttr(data);

      // we are checking if one of them is called data-header-tooltip
      const isTooltipRequired = attrs && Object.hasOwn(attrs, "data-header-tooltip");

      // Either we return the tooltip value (the text) or null;
      // NB every <th> own data attribute but it can be empty : {}
      return isTooltipRequired 
        ? attrs["data-header-tooltip"] 
        : null;
    }
  },
};
</script>
